export default "__VITE_ASSET__fad67a1e__"